import { useContext } from "react";
import { DrawerContext } from "@CONTEXTS";
import { Alert, Button, Descriptions, Tag } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/tr"; // Türkçe locale
import { previewFile } from "../../../../../api2/invoices";
import { GrDocumentPdf } from "react-icons/gr";
dayjs.locale("tr");

const InvoiceDetail = () => {
  const { data } = useContext(DrawerContext);
  return (
    <>
      {data ? (
        <>
          <Descriptions title={null} bordered column={1}>
            <Descriptions.Item label="Belge Numarası">
              {data?.e_invoice_number}
            </Descriptions.Item>
            <Descriptions.Item label="Açıklama">
              {data?.description}
            </Descriptions.Item>

            <Descriptions.Item label="Belge Kesim Tarihi">
              {data?.created_date && dayjs(data.created_date).isValid()
                ? dayjs(data.created_date).format("DD MMMM YYYY")
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Vade Tarihi">
              {data?.net_due_date && dayjs(data.net_due_date).isValid()
                ? dayjs(data.net_due_date).format("DD MMMM YYYY")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Belge Toplam Tutarı">
              {data?.invoice_amount != null
                ? `${new Intl.NumberFormat("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(Number(data.invoice_amount))} ₺`
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Ödenen Tutar">
              {data?.paid_amount != null
                ? `${new Intl.NumberFormat("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(Number(data.paid_amount))} ₺`
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Kalan Tutar">
              {data?.remaining_amount != null
                ? `${new Intl.NumberFormat("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(Number(data.remaining_amount))} ₺`
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Gecikme Gün Sayısı">
              {data?.payment_status !== "Ödendi" &&
              data?.net_due_date &&
              dayjs(data.net_due_date).isValid()
                ? dayjs()
                    .startOf("day")
                    .diff(dayjs(data.net_due_date).startOf("day"), "day")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Ödeme Tarihi">
              {data?.payment_date && dayjs(data.payment_date).isValid()
                ? dayjs(data.payment_date).format("DD MMMM YYYY")
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Ödeme Durumu">
              <Tag
                color={
                  data?.payment_status === "Ödendi"
                    ? "green"
                    : data?.payment_status === "Ödenmedi"
                    ? "red"
                    : "orange"
                }
                style={{ borderRadius: 8, fontSize: 16 }}
              >
                {data?.payment_status}
              </Tag>
            </Descriptions.Item>
          </Descriptions>
          {/* {data?.uuid && (
            <Button
              type="primary"
              style={{
                background: "#7723db",
                color: "whitesmoke",
                marginTop: 16,
                float: "right",
              }}
              onClick={async () => {
                const response = await previewFile(data?.uuid);
                if (response?.data) {
                  const blob = new Blob([response.data], {
                    type: "application/pdf",
                  });
                  const blobUrl = window.URL.createObjectURL(blob);
                  window.open(blobUrl);
                }
              }}
            >
              <GrDocumentPdf /> Faturayı Görüntüle
            </Button>
          )} */}
        </>
      ) : (
        <Alert showIcon type="info" message="Fatura detayı getirilemedi." />
      )}
    </>
  );
};
export default InvoiceDetail;
